<template>
  <UploadCard :title="`${capitalizedType} DOIs`">
    <div class="text-faded">
      Download the Excel template and add DOIs or upload a single DOI. If uploading the template, please make sure you
      haven't changed the order or deleted any columns.
    </div>

    <div class="grid-display">
      <q-btn @click="downloadTemplate">{{ capitalizedType }} template</q-btn>
      <FileUploader v-model="file" no-files-title="Choose or drag file" />
      <q-btn :loading="uploadLoading" :disable="!file" @click="upload">
        Upload
      </q-btn>
    </div>

    <div class="text-faded">OR</div>

    <InputFetch v-model="input" :loading="fetchLoading" @click="storeArticle" />
  </UploadCard>
</template>

<script>
import * as apiTo from '../api'
import { downloadFile } from '@/lib/generic.utils'
// Libraries
import { capitalize } from 'lodash'
// Components
import FileUploader from '@/reusable/FileUploader/FileUploader'
import UploadCard from './UploadCard'
import InputFetch from './InputFetch'

export default {
  components: {
    FileUploader,
    UploadCard,
    InputFetch
  },

  props: {
    type: {
      type: String,
      required: true,
      validator: val => ['publisher', 'member'].includes(val)
    }
  },

  data: () => ({
    uploadLoading: false,
    file: null,
    input: '',
    fetchLoading: false
  }),

  computed: {
    capitalizedType() {
      return capitalize(this.type)
    }
  },

  methods: {
    storeArticle() {
      this.fetchLoading = true
      apiTo
        .storeArticle({ doi: this.input, source: this.type })
        .then(() => (this.input = ''))
        .finally(() => (this.fetchLoading = false))
    },

    upload() {
      this.uploadLoading = true
      apiTo
        .uploadDoiFile(this.type, this.file)
        .then(() => (this.file = null))
        .finally(() => (this.uploadLoading = false))
    },

    downloadTemplate() {
      apiTo.getTemplateDownloadLink(this.type).then(response => downloadFile(response))
    }
  }
}
</script>

<style lang="stylus" scoped>
.grid-display {
  display grid
  gap 10px
}
</style>
